/* global Swiper */

const newsSliders = document.querySelectorAll('.news .swiper')

function news () {
  newsSliders.forEach((slider) => {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      preloadImages: false,
      lazy: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: slider.parentNode.parentNode.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
    })
  })
}

if (newsSliders.length > 0) {
  news()
}
